// extracted by css-extract-rspack-plugin
export default {"userRestrictedContainer":"UserRestrictedView-module__userRestrictedContainer__N0flr","backToAllIssuesButton":"UserRestrictedView-module__backToAllIssuesButton__jRXow"};